module.exports = __webpack_public_path__ + "static/media/image-thumb-1.48b74a81.jpeg";